import request from '@/utils/request.js'
import { oss } from '@/utils/aliyunoss'

//登录
export const accountLogin = function(data) {
	return request.post("/login", data);
}
//注册
export const register = function(data) {
	return request.post("/mobile-register", data);
}
//注册验证
export const validMobile = function(data) {
	return request.post("/valid-mobile", data);
}
export const findPassword = function(data) {
	return request.post("/find-password", data);
}

export const GetManageRefundAddress = function(data) {
	return request.post("/util/refundAddressConfig", data);
}

//发送验证码
export const sendSms = function(data) {
	return request.post("/util/sms", data);
}

export const profile = function(data) {
	return request.get("/member/profile", data);
}
export const updateProfile = function(data) {
	return request.post("/member/update", data);
}
export const revisePassword = function(data) {
	return request.post("/member/revise-password", data);
}
export const revisePayPassword = function(data) {
	return request.post("/member/revise-pay-password", data);
}
export const accountGeneral = function(data) {
	return request.get("/account/general", data);
}
//明细
export const accountHistory = function(data) {
	return request.get("/account/history", data);
}

// 地址管理
export const myAddressList = function(data) {
	return request.get("/address/list", data);
}
export const getAddress = function(data) {
	return request.get("/address/get", data);
}
export const saveAddress = function(data) {
	return request.post("/address/save", data);
}
export const deleteAddress = function(data) {
	return request.post("/address/delete", data);
}
export const defaultAddress = function(data) {
	return request.post("/address/set_default", data);
}

// 订单相关
export const getOrderList = function(data) {
	return request.get("/order/list", data);
}
export const getOrderDetail = function(data) {
	return request.get("/order/detail", data);
}
export const getOrderBill = function(data) {
	return request.get("/order/bill", data);
}
export const getOrderBills = function(data) {
	return request.get("/order/bills", data);
}
export const payOrder = function(data) {
	return request.post("/order/pay", data);
}
export const reviseOrderFigure = function(data) {
	return request.post("/order/revise-figure", data);
}
export const getPayStatus = function (data) {
	return request.get("/pay/status", data);
}
export const confirmOrder = function(data) {
	return request.post("/order/confirm", data);
}
export const questionList = function(data) {
	return request.get("/question/list", data);
}
export const questionDetailList = function(data) {
	return request.get("/question/detail-list", data);
}
export const cancelOrder = function(data) {
	return request.post("/order/cancel", data);
}
export const getOrderCount = function(data) {
	return request.post("/order/order_count", data);
}


export const getContentList = function(data) {
	return request.get("/content/all", data);
}
export const getContentHotList = function(data) {
	return request.get("/content/hot", data);
}
export const getContent = function(data) {
	return request.get("/content/get", data);
}
export const getPreNextContent = function(data) {
	return request.get("/content/pre-next", data);
}


export const getServiceList = function(data) {
	return request.get("/service/list", data);
}
//量体
export const getFigureList = function(data) {
	return request.get("/figure/list", data);
}
export const getFigure = function(data) {
	return request.get("/figure/get", data);
}
export const saveFigure = function(data) {
	return request.post("/figure/save", data);
}
export const deleteFigure = function(data) {
	return request.post("/figure/delete", data);
}
export const getBodyMeta = function(data) {
	return request.get("/figure/get-body-meta", data);
}
export const getFigureMeta = function(data) {
	return request.get("/figure/get-figure-meta", data);
}
export const getMtmSetting = function(data) {
	return request.get("/figure/get-setting", data);
}

//获取PC配置
export const getSetting = function (data) {
	return request.get("/setting/pc", data);
}

//获取PC配置
export const getHomeDeco = function (data) {
	return request.get("/home/pc", data);
}


//阿里云OSS
export const getOssToken  = function(data) {
	return request.get("/util/get-oss-token", data);
}
// OSS前端直传
export const uploadOss = async function(file, options = {}) {
	let config = await oss(file.name);
	let data = {...config, file}
	let newParams = new FormData;
	for (let i in data) {
		newParams.append(i, data[i])
	}
	options = {
		...options,
		headers: {
			'Content-Type': 'multipart/form-data',
			'api-usage' : 'oss'
		}
	}
	await request.post(config.host, newParams, options)
	return (config.oss_url + config.key)
}
// 文件后端上传
export const uploadFile = async function(file, dir, options = {}) {
	let data = {dir, file}
	let newParams = new FormData;
	for (let i in data) {
		newParams.append(i, data[i])
	}
	options = {
		...options,
		headers: {
			'Content-Type': 'multipart/form-data',
		}
	}

	return await request.post('/util/upload-image', newParams, options)
}

// 高定相关
export const MCategoryAvailableMtmType = function (data) {
	return request.get("/mtm/get-category-available-mtm-type", data);
}
export const MCategory = function (data) {
	return request.get("/mtm/category", data);
}
export const MTemplate = function (data) {
	return request.get("/mtm/template", data);
}
export const MTemplateDetail = function (data) {
	return request.get("/mtm/template-detail", data);
}
export const MPick = function (data) {
	return request.get("/mtm/pick", data);
}
export const getFigureCustomers = function(data) {
	return request.get("/figure/customers", data);
}
export const checkFigureMobile = function(data) {
	return request.get("/figure/check_mobile", data);
}
export const MDeliveryTemplate = function (data) {
	return request.get("/checkout/template", data);
}
export const MDeliveryTime = function (data) {
	return request.get("/checkout/time", data);
}
export const MEstimate = function (data) {
	return request.post("/mtm/estimate", data);
}
export const MEstimateMulti = function (data) {
	return request.post("/mtm/estimate-multi", data);
}
export const MSubmit = function (data) {
	return request.post("/mtm/submit", data);
}
export const MSubmitMulti = function (data) {
	return request.post("/mtm/submit-multi", data);
}
export const MPicture = function (data) {
	return request.post("/mtm/picture", data);
}
export const MFormulateCalculate = function (data) {
	return request.post("/mtm/get_formulate_result", data);
}
export const MTaohaoCalculate = function (data) {
	return request.post("/mtm/get_taohao_result", data);
}
export const MPictureCategory = function (data) {
	return request.get("/mtm/pictureCategory", data);
}
export const MPictures = function (data) {
	return request.get("/mtm/pictures", data);
}

export const MAccessoryColor = function (data) {
	return request.get("/mtm/accessory-color", data);
}


export const ApplyRefund = function(data) {
	return request.post("/order/apply-refund", data);
}
export const ReapplyRefund = function(data) {
	return request.post("/refund/re-apply", data);
}
export const GetRefundList = function(data) {
	return request.get("/refund/list", data);
}
export const CancelRefund = function(data) {
	return request.post("/refund/cancel", data);
}
export const ApplyDetail = function(data) {
	return request.get("/refund/apply-detail", data);
}
export const ConfirmRefund = function(data) {
	return request.post("/refund/confirm", data);
}
export const CustomerSend = function(data) {
	return request.post("/refund/customer-send", data);
}

export const GetLabelList = function (data) {
	return request.get("/mtm/label-list", data);
}

//我的优惠券
export const GetUserCopupon  = function(data) {
	return request.get("/member/coupon", data);
}

export const getStoreList = function(data) {
	return request.get("/util/stores", data);
}

